<template>
    <div class="button-container">
        <v-btn @click="onClick" content="Media" v-tippy="{placement: 'left'}" :class="{'v-btn--active': isRightColumn('project')}">
            <i class="material-symbols-outlined">home_storage</i>
        </v-btn>
        <div class="notification-counter-container">
            <NewCommentNotificationsCounter :count="newCommentNotificationsOfProject.length"
                                            class="ml-auto"
            />
        </div>
    </div>
</template>

<script>
import NewCommentNotificationsCounter from "@/components/app/notifications/NewCommentNotificationsCounter.vue";
import { mapGetters } from "vuex";

export default {
    components: {NewCommentNotificationsCounter},
    computed: {
        ...mapGetters('UI', ['isRightColumn']),
        ...mapGetters('Notifications', ['newCommentNotificationsOfProject'])
    },
    methods: {
        onClick() {
            this.$store.dispatch('UI/setRightColumn', 'project')
        },
    },
};
</script>

<style lang="scss" scoped>
.button-container {
    position: relative;
}

.notification-counter-container {
    position: absolute;
    left: 60%;
    top: -20%;
    z-index: 5;
}
</style>
